const TIMEZONE = 'America/New_York';
import { easternDateTime } from './kickoff';

const pad = (value) => String(value).padStart(2, '0');
const compact = (date, time) => `${date.replace(/-/g, '')}T${time.replace(':', '')}00`;
const escapeIcs = (value) => String(value || '').replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\r?\n/g, '\\n');

const addHours = (time, hours) => {
  const [h, m] = time.split(':').map(Number);
  return `${pad(Math.min(23, h + hours))}:${pad(m)}`;
};

export const gameEventDetails = (item) => {
  const title = (item.notes || '').split('·')[0].trim() || 'Brookline JP Patriots Game';
  const start = item.startTime;
  const end = item.endTime ? addHours(item.endTime, 2) : addHours(item.startTime, 3);
  return { title, start, end, date: item.date, location: item.location || '', description: item.notes || '' };
};

export const googleCalendarUrl = (item) => {
  const event = gameEventDetails(item);
  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: event.title,
    dates: `${compact(event.date, event.start)}/${compact(event.date, event.end)}`,
    ctz: TIMEZONE,
    details: event.description,
    location: event.location,
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
};

export const buildIcs = (item) => {
  const event = gameEventDetails(item);
  const stamp = new Date().toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
  const alarmAt = easternDateTime(event.date, '08:00');
  const alarm = alarmAt ? [
    'BEGIN:VALARM',
    'ACTION:DISPLAY',
    `DESCRIPTION:${escapeIcs(`Game day! ${event.title} — report ${event.start} at ${event.location}`)}`,
    `TRIGGER;VALUE=DATE-TIME:${alarmAt.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '')}`,
    'END:VALARM',
  ] : [];
  return [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Brookline JP Patriots//Football Schedule//EN',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    'BEGIN:VEVENT',
    `UID:${item.id}@brooklinejppatriots.com`,
    `DTSTAMP:${stamp}`,
    `DTSTART;TZID=${TIMEZONE}:${compact(event.date, event.start)}`,
    `DTEND;TZID=${TIMEZONE}:${compact(event.date, event.end)}`,
    `SUMMARY:${escapeIcs(event.title)}`,
    `DESCRIPTION:${escapeIcs(event.description)}`,
    `LOCATION:${escapeIcs(event.location)}`,
    ...alarm,
    'END:VEVENT',
    'END:VCALENDAR',
  ].join('\r\n');
};

export const downloadIcs = (item) => {
  const blob = new Blob([buildIcs(item)], { type: 'text/calendar;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${gameEventDetails(item).title.replace(/[^a-z0-9]+/gi, '-').toLowerCase()}-${item.date}.ics`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
};

export const directionsUrl = (location) => `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(location || '')}`;
